module.exports = __webpack_public_path__ + "27e1b1bb6f47d4628117023eb9ddaac6.svg";